import { render, staticRenderFns } from "./alarm-column-value-extra-details.vue?vue&type=template&id=e6b14df8&"
import script from "./alarm-column-value-extra-details.vue?vue&type=script&lang=js&"
export * from "./alarm-column-value-extra-details.vue?vue&type=script&lang=js&"
import style0 from "./alarm-column-value-extra-details.vue?vue&type=style&index=0&id=e6b14df8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports